import type {
  CollectionSale,
  MotiveSale,
  SalesCounters,
  TopicGroupSale,
  TopicSale,
} from '@/api/sales/types'
import type { BarDatum } from '@/components/charts/BarList'

/**
 * Vereinheitlichte Zeile über alle vier Verkaufsebenen.
 *
 * Die vier DTOs unterscheiden sich nur in ihren Bezugsgrößen (eine
 * Kollektions-Id hier, ein Themen- und Themengruppenpaar dort), tragen aber
 * dieselben sechs Zählerfelder. Für Tabelle und Rangliste reicht ein
 * einziges Zeilenformat, reine Funktionen ohne React.
 */
export interface SalesRow {
  readonly key: string
  readonly label: string
  readonly counters: SalesCounters
}

function counters(item: SalesCounters): SalesCounters {
  return {
    sales7: item.sales7,
    sales30: item.sales30,
    sales60: item.sales60,
    sales90: item.sales90,
    sales365: item.sales365,
    salesTotal: item.salesTotal,
  }
}

export function collectionSaleRow(item: CollectionSale): SalesRow {
  return {
    key: String(item.collectionId),
    label: item.collectionName ?? `Kollektion ${String(item.collectionId)}`,
    counters: counters(item),
  }
}

export function motiveSaleRow(item: MotiveSale): SalesRow {
  return {
    key: item.motiveKey,
    label: item.motiveName ?? item.motiveKey,
    counters: counters(item),
  }
}

export function topicGroupSaleRow(item: TopicGroupSale): SalesRow {
  return {
    key: String(item.topicGroupId),
    label: item.topicGroupName ?? `Themengruppe ${String(item.topicGroupId)}`,
    counters: counters(item),
  }
}

export function topicSaleRow(item: TopicSale): SalesRow {
  return {
    key: String(item.topicId),
    label: item.topicName ?? `Thema ${String(item.topicId)}`,
    counters: counters(item),
  }
}

/** Rangliste nach Gesamtverkäufen für die geladene Seite. */
export function topSalesRows(rows: readonly SalesRow[]): readonly BarDatum[] {
  return rows.map((row) => ({ label: row.label, value: row.counters.salesTotal }))
}
